export default __webpack_public_path__ + "static/media/icon_menu.590c8221.svg";